export const wheelPopup = (): void => {
  window.addEventListener('load', () => {
    const scrollToWheelBtn = document.querySelector<HTMLAnchorElement>('.wheel-button');
    const wheelSection = document.querySelector<HTMLElement>('#wheel');

    if (!scrollToWheelBtn || !wheelSection || typeof Boxzilla?.dismiss !== 'function') {
      console.warn('wheelPopup: Required elements or Boxzilla are missing.');
      return;
    }

    scrollToWheelBtn.addEventListener('click', () => {
      Boxzilla.dismiss();
      wheelSection.scrollIntoView({ behavior: 'smooth' });
    });
  });
};
